<template>
  <div>
    <TitlePage :title="$t('dashboard')"></TitlePage>
    <v-container fluid>
      <div class="dashboard-page">
        <v-row>
          <v-col cols="12">
            <v-chip color="primary" label small text-color="white">I miei campi</v-chip>
          </v-col>
          <template v-for="field in fields">
            <v-col lg="4" sm="6" md="4" cols="12">
              <v-card class="mx-auto" outlined elevation="2">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="text-overline mb-1">
                      <template v-for="sport of field.sports">
                        {{ sport.name }}
                      </template>
                    </div>
                    <v-list-item-title class="text-h5 mb-3 mt-0">
                      {{ field.name }}
                    </v-list-item-title>
                    <template v-if="field.date_next_promo_sa">
                      <div>
                        <small>Prossima attivazione Promo uCamp</small>
                        <br/>
                        <v-chip color="primary" dark small label outlined class="mt-2">
                          {{ new Date(field.date_next_promo_sa).toLocaleString() }}
                        </v-chip>
                        <v-chip color="orange" dark small label outlined class="mt-2">
                          <strong>{{getRemainingTime(field.date_next_promo_sa)}}</strong>
                        </v-chip>
                      </div>
                    </template>
                  </v-list-item-content>

                  <v-list-item-avatar tile size="90" color="grey">
                    <template v-if="field.image">
                      <v-img :src="field.image" :alt="field.name"/>
                    </template>
                    <template v-else>
                      <img src="../../assets/field-image-uc.png" :alt="field.name"/>
                    </template>

                  </v-list-item-avatar>
                </v-list-item>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn color="primary" dark x-small @click="liveCalendar(field._id)" class="ml-2">
                    {{ $t('bookings') }}
                  </v-btn>
                  <v-btn color="green" dark x-small @click="masterCalendar(field._id)" v-if="getRoleName !== 'Collaboratore'">
                    {{ $t('settings') }} {{ $t('calendar') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
        </v-row>
        <v-divider class="ma-5"></v-divider>
        <v-row>
          <v-col md="10" xs="12">
            <v-chip color="primary" label small text-color="white">Riepilogo Mensile</v-chip>
          </v-col>
          <v-col md="2" xs="12">
            <v-select dense :items="periods" v-model="period_selected" label="Periodo di Riferimento" hide-details
                      @change="changePeriod"></v-select>
          </v-col>
          <v-col cols="12">
            <v-card elevation="2">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Sport</th>
                    <th>N° Prenotazioni</th>
                    <th>Confermate</th>
                    <th>Da Confermare</th>
                    <th>Annullate</th>
                    <th>Guadagno</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in stats_to_show" :key="item.field_id">
                    <td>{{ getFieldName(item.field_id) }}</td>
                    <td>{{ getSportName(item.field_id, item.sport_id) }}</td>
                    <td>
                      <v-chip color="primary" small>{{ item.bookings_total }}</v-chip>
                    </td>
                    <td>
                      <v-chip color="success" small>{{ item.bookings_confirmed }}</v-chip>
                    </td>
                    <td>
                      <v-chip color="warning" small>{{ item.bookings_to_be_confirmed }}</v-chip>
                    </td>
                    <td>
                      <v-chip color="error" small>{{ item.bookings_cancelled }}</v-chip>
                    </td>
                    <td>
                      <v-chip color="info" small>{{ item.amount.toFixed(2) }} €</v-chip>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td><strong>Totali</strong></td>
                    <td>
                      <v-chip small>{{ totals_to_show.bookings_total }}</v-chip>
                    </td>
                    <td>
                      <v-chip small>{{ totals_to_show.bookings_confirmed }}</v-chip>
                    </td>
                    <td>
                      <v-chip small>{{ totals_to_show.bookings_to_be_confirmed }}</v-chip>
                    </td>
                    <td>
                      <v-chip small>{{ totals_to_show.bookings_cancelled }}</v-chip>
                    </td>
                    <td>
                      <v-chip small>{{ totals_to_show.amount.toFixed(2) }} €</v-chip>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="12" v-if="filters.center_id && filters.to && filters.from">
            <ReservationBySlotAndWeekday :filters="filters"/>
          </v-col>
        </v-row>
        <template v-if="getRoleName !== 'Collaboratore'">
          <v-divider class="ma-5"></v-divider>
          <v-row v-if="!apexLoading">
            <v-col cols="12">
              <v-chip color="primary" label small text-color="white">Andamento Annuale</v-chip>
            </v-col>
            <v-col md="4" xs="12">
              <v-card elevation="2" class="mb-2">
                <v-card-text @click="goTofields" style="cursor: pointer" title="Vai ai Campi">
                  <v-banner color="accent" dark single-line>
                    <v-chip color="green" class="mr-2">
                      {{ fields.length }}
                    </v-chip>
                    N° Campi Centro Sportivo
                  </v-banner>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="4" xs="12">
              <v-card elevation="2" class="mb-2">
                <v-card-text @click="goToBookings" style="cursor: pointer" title="Vai alle Prenotazioni">
                  <v-banner color="green" dark single-line>
                    <v-chip color="primary" class="mr-2">
                      {{ totals.bookings_total }}
                    </v-chip>
                    N° Prenotazioni Annuali
                  </v-banner>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="4" xs="12">
              <v-card elevation="2" class="mb-2">
                <v-card-text @click="goToTransactions" style="cursor: pointer" title="Vai alle Transazioni">
                  <v-banner color="grey" dark single-line>
                    <v-chip class="mr-2">
                      {{ totals.amount.toFixed(2) }} €
                    </v-chip>
                    Guadagno Annuo
                  </v-banner>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="4" xs="12">
              <v-card elevation="2">
                <v-card-title class="pa-6 pb-0">
                  <v-row no-gutters>
                    <v-col cols="12" class="d-flex align-center">
                      <p>Report Annuale Prenotazioni per mese</p>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12">
                      <ApexChart type="line" :options="annualBooking.options"
                                 :series="annualBooking.series"></ApexChart>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="4" xs="12">
              <v-card elevation="2">
                <v-card-title class="pa-6 pb-0">
                  <v-row no-gutters>
                    <v-col cols="12" class="d-flex align-center">
                      <p>Report Annuale Guadagno per mese</p>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col>
                      <ApexChart type="line" :options="annualAmount.options" :series="annualAmount.series"></ApexChart>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="4" xs="12">
              <v-card class="mx-1 mb-1" elevation="2">
                <v-card-title class="flex-nowrap pa-6 pb-3">
                  <p class="text-truncate">Report per Status</p>
                </v-card-title>
                <v-card-text class="pa-6 pt-0 mb-1">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <ApexChart type="donut" class="mt-1" :options="statusesAnnualOverview.options"
                                 :series="statusesAnnualOverview.series"/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <v-divider class="ma-5"></v-divider>
        <v-row>
          <v-col md="10" xs="12">
            <v-chip color="primary" label small text-color="white">Ultime Prenotazioni</v-chip>
          </v-col>
          <v-col md="12">
            <v-card elevation="2">
              <div>
                <v-data-table :headers="headers" :items="bookings.results" class="elevation-1" disable-pagination hide-default-footer>

                  <template v-slot:item.code="{ item }">
                    <strong>{{ item.code }}</strong>
                  </template>

                  <template v-slot:item.customer="{ item }">
                    <template v-if="item.customer[0]">
                      {{ item.customer[0].name }} {{ item.customer[0].surname }}
                    </template>
                    <template v-else-if="item.note">
                      {{item.note}}
                    </template>
                    <template v-else>
                      N.D.
                    </template>
                  </template>

                  <template v-slot:item.center="{ item }">
                    <template v-if="item.center[0]">
                      {{ item.center[0].name }}
                    </template>
                    <template v-else>
                      N.D.
                    </template>
                  </template>

                  <template v-slot:item.field="{ item }">
                    <template v-if="item.field[0]">
                      {{ item.field[0].name }}
                    </template>
                    <template v-else>
                      N.D.
                    </template>
                  </template>

                  <template v-slot:item.sport="{ item }">
                    {{ item.sport[0].name }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip small :color="getStatus(item.status, 'color')">{{ getStatus(item.status, 'name') }}</v-chip>
                  </template>

                  <template v-slot:item.price="{ item }">
                    {{ item.price.toFixed(2) }} €
                  </template>

                  <template v-slot:item.date="{ item }">
                    {{ getSlot(item.date, item.slot_id) }}
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    {{ new Date(item.created_at).toLocaleString() }}
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-icon @click="editBooking(item._id)" :title="$t('edit')" color="primary">mdi-file-edit</v-icon>
                  </template>

                </v-data-table>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitlePage from "../utils/TitlePage";
import {mapActions, mapGetters, mapMutations} from "vuex";
import ApexChart from "vue-apexcharts";
import ReservationBySlotAndWeekday from "@/components/analytics/ReservationBySlotAndWeekday.vue";

export default {
  name: "DashboardAdmin",
  computed: {
    ...mapGetters({
      'getRoleName': 'user/getRoleName',
      'getUser': 'user/getUser'
    }),
  },
  components: {ReservationBySlotAndWeekday, TitlePage, ApexChart},
  data() {
    return {
      filters: {},
      periods: [],
      period_selected: '',
      apexLoading: false,
      pathFields: '/fields/',
      pathEdit: '/fields/edit/',
      pathEditBooking: '/bookings/edit/',
      pathSettings: '/fields/settings/',
      pathCalendar: '/fields/calendar/',
      pathLiveCalendar: '/fields/live-calendar/',
      pathMasterCalendar: '/fields/master-calendar/',
      pathBookings: '/bookings/',
      pathTransactions: '/transactions/',
      fields: [],
      interval: [],
      stats: [],
      bookings: [],
      stats_to_show: [],
      totals_to_show: {
        bookings_total: 0,
        bookings_confirmed: 0,
        bookings_to_be_confirmed: 0,
        bookings_cancelled: 0,
        amount: 0
      },
      totals: {
        bookings_total: 0,
        bookings_confirmed: 0,
        bookings_to_be_confirmed: 0,
        bookings_cancelled: 0,
        amount: 0
      },
      totals_by_month: [],
      statusesAnnualOverview: {
        options: {
          dataLabels: {
            enabled: false
          },
          colors: ['#4CAF50', '#FFC107', '#FF5252'],
          labels: ["Completate", "Da Confermare", "Annullate"],
          legend: {}
        },
        series: [],
      },
      annualBooking: {
        options: {
          chart: {
            width: '100%',
            toolbar: {
              show: true
            },
          },
          dataLabels: {
            enabled: true
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              }
            },
            yaxis: {
              lines: {
                show: true,
              },
            }
          },
          markers: {
            size: [5, 0, 0]
          },
          stroke: {
            width: [3, 2, 2],
            curve: ['straight', 'smooth', "smooth", "smooth"]
          },
          fill: {
            type: 'linear',
          },
          legend: {
            show: true
          },
          colors: ['#1526c9', '#4CAF50', '#FFC107', '#FF5252'],
          yaxis: {
            axisBorder: {
              show: true,
              color: '#B9B9B980'
            },
            tickAmount: 5
          },
          xaxis: {
            categories: []
          }
        },
        series: [],
      },
      annualAmount: {
        options: {
          chart: {
            width: '100%',
            toolbar: {
              show: true
            },
          },
          dataLabels: {
            enabled: true
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              }
            },
            yaxis: {
              lines: {
                show: true,
              },
            }
          },
          markers: {
            size: [5, 0, 0]
          },
          stroke: {
            width: [3],
            curve: ['straight']
          },
          fill: {
            type: 'linear',
          },
          legend: {
            show: true
          },
          colors: ['#1526c9'],
          yaxis: {
            axisBorder: {
              show: true,
              color: '#B9B9B980'
            },
            tickAmount: 5
          },
          xaxis: {
            categories: []
          }
        },
        series: [],
      },
      headers: [
        {text: this.$t('code'), align: 'start', value: 'code'},
        {text: this.$t('customer'), align: 'start', value: 'customer'},
        {text: this.$t('sportsCenter'), value: 'center'},
        {text: this.$t('field'), value: 'field'},
        {text: this.$t('sports'), value: 'sport'},
        {text: this.$t('status'), value: 'status', sortable: false},
        {text: this.$t('amount'), value: 'price', sortable: false},
        {text: this.$t('date'), value: 'date'},
        {text: this.$t('creation_date'), value: 'created_at'},
        {text: this.$t('actions'), align: 'start', value: 'action',},
      ],
    };
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getDashboardAdminInfo': 'stats/getDashboardAdminInfo',
      'getPromoSuperAdminStats': 'stats/getPromoSuperAdminStats',
    }),

    changePeriod() {
      this.setLoading(true);
      this.stats_to_show = []
      this.totals_to_show = {
        bookings_total: 0,
        bookings_confirmed: 0,
        bookings_to_be_confirmed: 0,
        bookings_cancelled: 0,
        amount: 0
      }
      for (let field of this.stats) {
        for (let s of field) {
          if (s.period == this.period_selected) {
            this.stats_to_show.push(s)
            this.totals_to_show.bookings_total += s.bookings_total
            this.totals_to_show.bookings_confirmed += s.bookings_confirmed
            this.totals_to_show.bookings_to_be_confirmed += s.bookings_to_be_confirmed
            this.totals_to_show.bookings_cancelled += s.bookings_cancelled
            this.totals_to_show.amount += s.amount
          }
        }
      }

      this.filters.from = this.getDateRangeFromMonthYear(this.period_selected).from.getTime()
      this.filters.to = this.getDateRangeFromMonthYear(this.period_selected).to.getTime()

      this.setLoading(false);
    },

    getStatus(status, type) {
      switch (status) {
        case "completed":
          return (type == 'name') ? 'Completata' : 'success'
        case "booked":
          return (type == 'name') ? 'Prenotato' : 'primary'
        case "to_be_payed":
          return (type == 'name') ? 'Da Pagare' : 'info'
        case "canceled":
        case "refunded":
          return (type == 'name') ? 'Annullata' : 'error'
        case "interrupted":
          return (type == 'name') ? 'Interrotta' : 'warning'
        case "pending":
          return (type == 'name') ? 'In attesa' : 'info'
        case "to_be_confirmed":
          return (type == 'name') ? 'Da confermare' : 'warning'
        default:
          return (type == 'name') ? status : 'info'
      }
    },
    getSlot(date, slot_id) {
      var string_date = new Date(date).toLocaleDateString()
      var split = slot_id.split(';')
      string_date += ' | ' + split[3] + ' - ' + split[4]
      return string_date
    },
    getFieldName(_id) {
      var field = _.find(this.fields, {'_id': _id})
      return field.name
    },

    getSportName(_id, sport_id) {
      var field = _.find(this.fields, {'_id': _id})
      var sport = _.find(field.sports, {'_id': sport_id})
      return sport.name
    },
    edit(id) {
      this.$router.push(this.pathEdit + id)
    },
    editBooking(id) {
      this.$router.push(this.pathEditBooking + id)
    },
    settings(id) {
      this.$router.push(this.pathSettings + id)
    },
    calendar(id) {
      this.$router.push(this.pathCalendar + id)
    },
    liveCalendar(id) {
      this.$router.push(this.pathLiveCalendar + id)
    },
    masterCalendar(id) {
      this.$router.push(this.pathMasterCalendar + id)
    },
    goTofields() {
      this.$router.push(this.pathFields)
    },
    goToBookings() {
      this.$router.push(this.pathBookings)
    },
    goToTransactions() {
      this.$router.push(this.pathTransactions)
    },

    getRemainingTime(date){
      let date_future = new Date(date);
      let date_now = new Date();

      let seconds = Math.floor((date_future - (date_now))/1000);
      let minutes = Math.floor(seconds/60);
      let hours = Math.floor(minutes/60);
      let days = Math.floor(hours/24);

      hours = hours-(days*24);
      minutes = minutes-(days*24*60)-(hours*60);
      seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);

      return `- ${days}g ${hours}h ${minutes}m ${seconds}s`
    },

    getDateRangeFromMonthYear(input) {
      const [monthStr, yearStr] = input.split('_');
      const month = parseInt(monthStr, 10);
      const year = parseInt(yearStr, 10);

      const from = new Date(year, month - 1, 1, 0, 0, 0); // 1° giorno del mese alle 00:00
      const to = new Date(year, month, 0, 23, 59, 0);     // ultimo giorno del mese alle 23:59

      return { from, to };
    }
  },
  mounted() {
    this.interval = window.setInterval(() => {
      this.$forceUpdate();
    },1000);
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  },
  async created() {
    this.setLoading(true);
    const now = new Date();
    this.period_selected = `${now.getMonth() + 1}_${now.getFullYear()}`

    for (var i = 1; i <= 12; i++) {
      this.periods.push({
        text: `${i}/${now.getFullYear()}`,
        value: `${i}_${now.getFullYear()}`
      })

      this.annualBooking.options.xaxis.categories.push(`${i}/${now.getFullYear()}`)
      this.annualAmount.options.xaxis.categories.push(`${i}/${now.getFullYear()}`)
    }
    var results = await this.getDashboardAdminInfo({period: this.period_selected});

    this.fields = results.fields
    this.stats = results.stats
    this.bookings = results.bookings

    let result_sa = await this.getPromoSuperAdminStats({});

    result_sa.result.map((center) => {

      center.center_fields.map((field) => {

        let find_field = this.fields.find((f) => f._id.toString() === field._id.toString())
        if(find_field){
          if(!center.promo_sa_global.active || !field.promo_sa_global.active){
            find_field.promo_sa_status = 'not_enabled'
          }else if(center.promo_sa_global.active && field.promo_sa_global.active){
            find_field.promo_sa_status = 'enabled'
            find_field.promo_sa_start_date = (field.promo_sa_global.start_time) ? new Date(field.promo_sa_global.start_time).toLocaleDateString() : 'n.d.'
            find_field.promo_sa_end_date = (field.promo_sa_global.no_end) ? '∞' : new Date(field.promo_sa_global.end_time).toLocaleDateString()
            find_field.suspended = field.suspended
            find_field.date_next_promo_sa = field.date_next_promo_sa
            find_field.lastBooking = field.lastBooking
            find_field.days_unsold = field.days_unsold.toFixed(2)+' GG'
          }
        }

      })

    })

    for (let field of results.stats) {
      for (let s of field) {

        if (!this.totals_by_month[s.period]) {
          this.totals_by_month[s.period] = {
            bookings_total: 0,
            bookings_confirmed: 0,
            bookings_to_be_confirmed: 0,
            bookings_cancelled: 0,
            amount: 0
          }
        }

        this.totals_by_month[s.period].bookings_total += s.bookings_total
        this.totals_by_month[s.period].bookings_confirmed += s.bookings_confirmed
        this.totals_by_month[s.period].bookings_to_be_confirmed += s.bookings_to_be_confirmed
        this.totals_by_month[s.period].bookings_cancelled += s.bookings_cancelled
        this.totals_by_month[s.period].amount += s.amount

        if (s.period == this.period_selected) {
          this.stats_to_show.push(s)
          this.totals_to_show.bookings_total += s.bookings_total
          this.totals_to_show.bookings_confirmed += s.bookings_confirmed
          this.totals_to_show.bookings_to_be_confirmed += s.bookings_to_be_confirmed
          this.totals_to_show.bookings_cancelled += s.bookings_cancelled
          this.totals_to_show.amount += s.amount
        }
        this.totals.bookings_total += s.bookings_total
        this.totals.bookings_confirmed += s.bookings_confirmed
        this.totals.bookings_to_be_confirmed += s.bookings_to_be_confirmed
        this.totals.bookings_cancelled += s.bookings_cancelled
        this.totals.amount += s.amount
      }
    }

    var totals_series = {
      name: 'Totali', type: 'line', data: []
    }

    var completed_series = {
      name: 'Completate', type: 'line', data: []
    }

    var to_be_confirmed_series = {
      name: 'Da Confermare', type: 'line', data: []
    }

    var cancelled_series = {
      name: 'Annullate', type: 'line', data: []
    }

    var amount_series = {
      name: 'Guadagno', type: 'line', data: []
    }

    for (let p of this.periods) {

      var total = (this.totals_by_month[p.value]) ? this.totals_by_month[p.value].bookings_total : 0
      var completed = (this.totals_by_month[p.value]) ? this.totals_by_month[p.value].bookings_confirmed : 0
      var to_be_confirmed = (this.totals_by_month[p.value]) ? this.totals_by_month[p.value].bookings_to_be_confirmed : 0
      var cancelled = (this.totals_by_month[p.value]) ? this.totals_by_month[p.value].bookings_cancelled : 0
      var amount = (this.totals_by_month[p.value]) ? this.totals_by_month[p.value].amount : 0

      totals_series.data.push(total)
      completed_series.data.push(completed)
      to_be_confirmed_series.data.push(to_be_confirmed)
      cancelled_series.data.push(cancelled)
      amount_series.data.push(amount)
    }

    this.annualBooking.series = [totals_series, completed_series, to_be_confirmed_series, cancelled_series]
    this.annualAmount.series = [amount_series]

    this.statusesAnnualOverview.series = [this.totals.bookings_confirmed, this.totals.bookings_to_be_confirmed, this.totals.bookings_cancelled]

    this.filters = {
      booking_type: 'all',
      sport_id: [],center_id: [this.getUser.center_id],
      from: this.getDateRangeFromMonthYear(this.period_selected).from.getTime(),
      to: this.getDateRangeFromMonthYear(this.period_selected).to.getTime(),
      user_id: null,
      lat: null,
      lng: null,
      radius_km: 2
    }

    this.apexLoading = false
    this.setLoading(false);
  },

}
</script>

<style>
.apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {
  top: 0!important;
}
</style>